import {
    LOCK_PATHS,
    LockPath,
} from "components/asset-management-system/custom-views/tabs/risk/cards/risk-factors-card/lockedDevices";
import { FilterOperator, FilterPathType } from "domain/asset-management/assetFilterConstants";
import { AssetPathKey } from "domain/asset-management/assetPathMapping";
import {
    AssetDistributionRequest,
    AssetFilter,
    AssetSearchRequest,
    LockDistribution,
} from "services/asset-management/AssetService";

export interface LockedAssetsDistribution {
    totalCount: number;
    counts: Record<LockPath, number>;
}

export const EMPTY_LOCKED_ASSETS_DISTRIBUTION: LockedAssetsDistribution = {
    totalCount: 0,
    counts: {
        [AssetPathKey.AUTOPILOT_ENROLLMENT_STATE]: 0,
        [AssetPathKey.FIND_MY_IPHONE]: 0,
    },
};

const toExistsFilter = (lockPath: LockPath): AssetFilter => ({
    name: lockPath,
    value: "",
    operator: FilterOperator.EXIST,
    pathType: FilterPathType.KEYWORD,
});

export const buildLockedAssetsDistributionRequest = (viewRequest?: AssetSearchRequest): AssetDistributionRequest => ({
    filters: LOCK_PATHS.map(toExistsFilter),
    viewRequest,
});

export const toLockedAssetsDistribution = (distributions: LockDistribution[]): LockedAssetsDistribution => {
    const countOf = (lockPath: LockPath): number =>
        distributions.find((distribution) => distribution.path === lockPath)?.count ?? 0;
    const counts: Record<LockPath, number> = {
        [AssetPathKey.AUTOPILOT_ENROLLMENT_STATE]: countOf(AssetPathKey.AUTOPILOT_ENROLLMENT_STATE),
        [AssetPathKey.FIND_MY_IPHONE]: countOf(AssetPathKey.FIND_MY_IPHONE),
    };

    return {
        totalCount: LOCK_PATHS.reduce((total, lockPath) => total + counts[lockPath], 0),
        counts,
    };
};
